import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import Layout from "./components/pageParts/Layout";
import Fonts from "./components/misc/Fonts";

import theme from "./styles/theme";
import Home from "./screens/Home";
import Abroad from "./screens/Abroad";
import GlobalStyles from "./components/misc/GlobalStyles";
import Contact from "./screens/Contact";
import Verification from "./screens/Verification";
import Accident from "./screens/Accident";
import About from "./screens/About";
import Faq from "./screens/Faq";
import Legal from "./screens/Legal";
import Privacy from "./screens/Privacy";
import Terms from "./screens/Terms";
import { getPageListToShow } from "./helpers/helpers";
import { useState, useEffect } from "react";

function App() {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const [filteredPages, setFilteredPages] = useState();

  useEffect(() => {
    const filterPages = async () => {
      const result = await getPageListToShow(language);
      setFilteredPages(result);
    };
    filterPages(); // eslint-disable-next-line
  }, []);

  const hidePage = (page) => {
    return filteredPages?.some((item) => item.page === page && item.hide);
  };
  return (
    <>
      <ChakraProvider resetCSS theme={theme}>
        <GlobalStyles />
        <Fonts />
        <BrowserRouter>
          <Layout>
            <Switch>
              <Route path="/check" exact>
                <Home />
              </Route>
              {!hidePage("abroad") && (
                <Route path="/abroad" exact>
                  <Abroad />
                </Route>
              )}

              {!hidePage("accident") && (
                <Route path="/accident" exact>
                  <Accident />
                </Route>
              )}

              {!hidePage("access") && (
                <Route path="/verification" exact>
                  <Verification />
                </Route>
              )}
              <Route path="/about" exact>
                <About />
              </Route>
              <Route path="/faq" exact>
                <Faq />
              </Route>
              <Route path="/legal" exact>
                <Legal />
              </Route>
              <Route path="/contact" exact>
                <Contact />
              </Route>
              <Route path="/privacy" exact>
                <Privacy />
              </Route>
              <Route path="/terms" exact>
                <Terms />
              </Route>
              <Redirect to="/check" />
            </Switch>
          </Layout>
        </BrowserRouter>
      </ChakraProvider>
    </>
  );
}

export default App;
